import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDatabridgeSubscribe, RecommendationSliders, GenericRecommendationsContextProvider } from '@xp-utilities/web';
import { useWindowWidth } from '@react-hook/window-size';
import { handleOnRecommendedProductClick } from '../Recommendations/helpers';

export default function OrderDetailsRecommendations({ orderId }) {
  const retrievedWindowWidth = useWindowWidth();
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => { setWindowWidth(retrievedWindowWidth); }, [retrievedWindowWidth]);

  const isMobileView = windowWidth <= 699;
  const basePlacements = isMobileView
    ? ['generic_page.m_orderHistory1']
    : ['generic_page.orderHistory1'];

  const isEnabled = useDatabridgeSubscribe('flag.ful-dre-2-0-product-recs-order-details', false);
  if (!isEnabled) return null;

  const effectivePlacements = basePlacements;

  const onRecommendedProductClick = (...args) => handleOnRecommendedProductClick(false, ...args);

  return (
    <div className="order-details-recommendations" data-testid="order-details-recommendations">
      <GenericRecommendationsContextProvider>
        <RecommendationSliders
          placements={effectivePlacements}
          onProductClick={onRecommendedProductClick}
          useGrid={isMobileView}
          queryOptions={{ variables: { orderId, hideSwatches: false } }}
        />
      </GenericRecommendationsContextProvider>
    </div>
  );
}

OrderDetailsRecommendations.propTypes = { orderId: PropTypes.string };
OrderDetailsRecommendations.defaultProps = { orderId: '' };
